/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { FaCheckCircle } from "react-icons/fa";
import { 
  User, 
  Mail, 
  Building, 
  MapPin,
  CreditCard,
  Lock,
  ArrowLeft,
  SendIcon,
  X,
  Loader2
} from "lucide-react";
import api from "../services/api";
import FreePlanModal from "./FreePlanModal";

const PricingPlans = () => {
  const navigate = useNavigate();
  const [planType, setPlanType] = useState('');
  const user_id = localStorage.getItem('user_id');
  const account_id = localStorage.getItem('account_id');
  const [company_size, setCompanySize] = useState(1);
  const company_name = localStorage.getItem('company_name');
  const [showFreePlanModal, setShowFreePlanModal] = useState(false);
  const [showEnterpriseConfirmModal, setShowEnterpriseConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enterpriseLoading, setEnterpriseLoading] = useState(false);
  const [businessLoading, setBusinessLoading] = useState(false);

  const handleSelectPlan = async (plan) => {
    setPlanType(plan);
    if (plan === 'Enterprise') {
      setShowEnterpriseConfirmModal(true);
    } else if (plan === 'Startup') {
      setShowFreePlanModal(true);
    } else {
      setBusinessLoading(true);
      try {
        const formdata = {
          amount: 159,
          product_name: `Business for ${company_name}`,
          surcharge: 0,
          plan_type: plan,
          number_of_users: company_size,
        }
        const response = await api.getPaymentLink(account_id, formdata);
        if (response.status === 'success') {
          window.location.href = response.data;
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong');
      } finally {
        setBusinessLoading(false);
      }
    }
  };

  const handleBack = () => {
    navigate('/user-details');
  };

  const handleCloseModal = () => {
    setShowFreePlanModal(false);
  };

  const handleCloseEnterpriseModal = () => {
    setShowEnterpriseConfirmModal(false);
    setPlanType(''); // Reset plan type
  };

  const handleConfirmEnterprisePlan = () => {
    setShowEnterpriseConfirmModal(false);
    handleEnterprisePlan();
  };

  const handleEnterprisePlan = async () => {
    setEnterpriseLoading(true);
    try {
      const response = await api.submitEnterprisePlan({
        company_id: localStorage.getItem('company_id'),
        user_id: localStorage.getItem('user_id'),
        plan_type: 'Enterprise',
      });
      if (response.status === 'success') {
        navigate('/enterprise-contact');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.response.data.message || 'Something went wrong');
    } finally {
      setEnterpriseLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center items-center h-screen">
      <Loader2 className="animate-spin" size={24} />
    </div>
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4 sm:p-6">
      <div className="flex justify-center mb-10">
        <img
          src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2025-03-18/full_logo.a46683a620fa53c3c554_1742299090688.png"
          alt="SalesCaptain Logo"
          className="h-10 object-contain"
        />
      </div>

      <div className="w-full max-w-6xl mx-auto px-4">
        <h1 className="text-xl md:text-2xl font-semibold text-center mb-2 ">
          {/* <button
            onClick={handleBack}
            className="flex items-center gap-2 border border-gray-200 text-blue-600 rounded-lg py-2 px-4 text-sm hover:bg-blue-50"
          >
            <ArrowLeft size={16} /> Back
          </button> */}
          You're just one step away from getting started with your plan
        </h1>
        {/* <p className="text-gray-500 text-center mb-8">
          Choose a plan to start your <span className="font-medium">7-day</span> free trial.
          <br /> You can change or cancel at any time.
        </p> */}
        {/* <div className="space-y-2">
          <label htmlFor="numUsers" className="flex items-center gap-2 text-sm font-medium">
            <Building className="h-4 w-4 text-blue-600" />
            Number of Users <span className="text-red-500">*</span>
          </label>
          <input
            id="numUsers"
            name="numUsers"
            type="number"
            min="1"
            value={company_size}
            onChange={(e) => setCompanySize(e.target.value)}
            className="w-full h-10 px-3 border border-gray-200 rounded-lg focus:border-blue-500 focus:outline-none"
            required
          />
          <p className="text-sm text-gray-500">
            Enter the number of users in your business/company
          </p>
        </div> */}
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 pt-5'>
          {/* Startup Plan */}
          <div
            onClick={() => setPlanType('Startup')}
            className={`flex flex-col ${planType === 'Startup' ? `bg-gradient-to-br from-green-50 to-emerald-50 shadow-lg border border-green-200` : `bg-white hover:shadow-lg border border-gray-200`} rounded-xl overflow-hidden cursor-pointer transition-all duration-300 h-[600px] relative`}
          >
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-green-500 to-emerald-500"></div>
            
            {/* Fixed Header */}
            <div className="p-6 pb-4 flex-shrink-0">
              <div className="flex justify-between items-center mb-4">
                <span className="text-lg font-semibold text-gray-800">Startup</span>
                <div className="flex items-baseline">
                  <span className="text-2xl font-bold text-gray-800">$0</span>
                  <span className='text-sm text-gray-500 ml-1'>/month</span>
                </div>
              </div>

              <p className="text-sm text-gray-600 mb-4">
                Forever Free with one-time credit purchase. Pay only for what you use.
              </p>

              <h3 className="text-sm font-semibold text-gray-800">What's Included</h3>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6 pb-4">
              {[
                '$10 one-time credit (free)',
                'Free Port/Host Number',
                'Unlimited Users',
                'All Platform Features (Texting, Calling, Social Chats, Webchat)',
                'Captain Labs Features (Automations, AI Agents, Chatflow, Callflow)',
                'Pay-per-use: $0.04/min calls, $0.015/message',
                'Extra Numbers: $5/month (pay for use)',
                'Extra Workspace: $10/month',
                'AI Text: $0.01/generation, AI Calls: $0.12/min',
                '48 hours Email Support'
              ].map((feature, index) => (
                <div key={index} className='flex items-center gap-3 mb-3'>
                  <FaCheckCircle className="text-green-600 flex-shrink-0" size={16} />
                  <span className='text-sm text-gray-700'>{feature}</span>
                </div>
              ))}
            </div>

            {/* Fixed Footer */}
            <div className='p-6 pt-4 bg-gradient-to-r from-green-50 to-emerald-50 border-t border-green-100 flex-shrink-0'>
              <div className="text-center mb-4">
                <p className="text-sm text-green-700 font-medium">
                  🚀 Perfect for startups and small teams getting started
                </p>
              </div>
              
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectPlan('Startup');
                }}
                className="w-full h-12 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-lg flex items-center justify-center text-sm font-semibold transition-all duration-200 shadow-lg"
              >
                <Lock size={16} className="mr-2" />
                Get Started Now
              </button>
            </div>
          </div>
          {/* Business Plan */}
          <div
            onClick={() => setPlanType('Business')}
            className={`flex flex-col ${planType === 'Business' ? `bg-gradient-to-br from-blue-50 to-indigo-50 shadow-lg border border-blue-200` : `bg-white hover:shadow-lg border border-gray-200`} rounded-xl overflow-hidden cursor-pointer transition-all duration-300 relative h-[600px] md:scale-105 md:shadow-lg md:z-10`}
          >
            <div className="absolute top-0 right-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs px-4 py-2 rounded-bl-xl font-semibold shadow-lg">
              ⭐ MOST POPULAR
            </div>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-indigo-500"></div>

            {/* Fixed Header */}
            <div className="p-6 pb-4 pt-8 flex-shrink-0">
              <div className="flex justify-between items-center mb-4">
                <span className="text-lg font-semibold text-gray-800">Business</span>
                <div className="flex items-baseline">
                  <span className="text-2xl font-bold text-gray-800">$159</span>
                  <span className='text-sm text-gray-500 ml-1'>/month</span>
                </div>
              </div>

              <p className="text-sm text-gray-600 mb-4">
                Unlimited plans for growing businesses
              </p>

              <h3 className="text-sm font-semibold text-gray-800">What's Included</h3>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6 pb-4">
              {[
                'Everything in Startup',
                'Free Port/Host Number',
                'Unlimited Calling & Inbox Texting',
                '5000 Text Marketing credits ($0.01/message)',
                'Extra Numbers: $25/month (unlimited)',
                'Extra Location: $159/month',
                'Extra Workspace: $159/month',
                'Unlimited AI Text Generations',
                '200 AI Phone Call minutes ($0.1/min extra)',
                '1 Free Hardphone (extra $100)',
                '2 hours Email & Text Support'
              ].map((feature, index) => (
                <div key={index} className='flex items-center gap-3 mb-3'>
                  <FaCheckCircle className="text-blue-600 flex-shrink-0" size={16} />
                  <span className='text-sm text-gray-700'>{feature}</span>
                </div>
              ))}
            </div>

            {/* Fixed Footer */}
            <div className='p-6 py-9 bg-gradient-to-r from-blue-50 to-indigo-50 border-t border-blue-100 flex-shrink-0'>
              <div className="text-center mb-4">
                <p className="text-sm text-blue-700 font-medium">
                  💼 Ideal for growing businesses and teams
                </p>
              </div>
              
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectPlan('Business');
                }}
                disabled={businessLoading}
                className={`w-full h-12 ${businessLoading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700'
                } text-white rounded-lg flex items-center justify-center text-sm font-semibold transition-all duration-200 shadow-lg`}
              >
                {businessLoading ? (
                  <>
                    <Loader2 className="animate-spin mr-2" size={16} />
                    Processing...
                  </>
                ) : (
                  <>
                    <Lock size={16} className="mr-2" />
                    Pay Securely $159
                  </>
                )}
              </button>
            </div>
          </div>
          {/* Enterprise Plan */}
          <div
            onClick={() => setPlanType('Enterprise')}
            className={`flex flex-col ${planType === 'Enterprise' ? `bg-gradient-to-br from-purple-50 to-blue-50 shadow-lg border border-purple-200` : `bg-white hover:shadow-lg border border-gray-200`} rounded-xl overflow-hidden cursor-pointer transition-all duration-300 h-[600px] relative`}
          >
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 to-blue-500"></div>
            
            {/* Fixed Header */}
            <div className="p-6 pb-4 flex-shrink-0">
              <div className="flex justify-between items-center mb-4">
                <span className="text-lg font-semibold text-gray-800">Enterprise</span>
                <div className="flex items-baseline">
                  <span className="text-xs text-gray-500 mr-1">starts at</span>
                  <span className="text-2xl font-bold text-gray-800">$300</span>
                  <span className='text-sm text-gray-500 ml-1'>/month</span>
                </div>
              </div>
              
              <p className="text-sm text-gray-600 mb-4">
                Custom solutions for large businesses with high-volume needs
              </p>
              
              <h3 className="text-sm font-semibold text-gray-800">What's Included</h3>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6 pb-4">
              {[
                'Everything in Business',
                'Free Port/Host Number',
                'Unlimited Calling & Inbox Texting',
                'Custom Text Marketing Credits',
                'Marketing - High Volume Support',
                'Custom Extra Numbers, Locations & Workspaces',
                'Custom AI Usage & Phone Calls',
                'Custom Hardphone Solutions',
                'Dedicated Relationship Manager',
                'Enterprise-tier Apps & Integrations'
              ].map((feature, index) => (
                <div key={index} className='flex items-center gap-3 mb-3'>
                  <FaCheckCircle className="text-purple-600 flex-shrink-0" size={16} />
                  <span className='text-sm text-gray-700'>{feature}</span>
                </div>
              ))}
            </div>
            
            {/* Fixed Footer */}
            <div className="p-6 pt-4 bg-gradient-to-r from-purple-50 to-blue-50 border-t border-purple-100 flex-shrink-0">
              <div className="text-center mb-4">
                <p className="text-sm text-purple-700 font-medium">
                  🤝 Our sales team will contact you soon to discuss your custom requirements
                </p>
              </div>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectPlan('Enterprise');
                }}
                disabled={enterpriseLoading}
                className={`w-full h-12 ${enterpriseLoading 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700'
                } text-white rounded-lg flex items-center justify-center text-sm font-semibold transition-all duration-200 shadow-lg`}
              >
                {enterpriseLoading ? (
                  <>
                    <Loader2 className="animate-spin mr-2" size={16} />
                    Submitting...
                  </>
                ) : (
                  <>
                    <SendIcon size={16} className="mr-2" />
                    Submit Request
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center mt-8">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 border border-gray-200 text-blue-600 rounded-lg py-2 px-4 text-sm hover:bg-blue-50"
          >
            <ArrowLeft size={16} /> Back
          </button>
        </div>
      </div>

      <FreePlanModal 
        isOpen={showFreePlanModal} 
        onClose={handleCloseModal}
        userPhone={localStorage.getItem('user_number')}
      />

      {showEnterpriseConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
            <button
              onClick={handleCloseEnterpriseModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X size={20} />
            </button>

            <div className="text-center space-y-4">
              <Building className="h-16 w-16 text-blue-600 mx-auto" />
              <h2 className="text-xl font-semibold">
                Confirm Enterprise Plan
              </h2>
              <p className="text-gray-600">
                Are you sure you need to proceed with the Enterprise plan? Our sales team will contact you to discuss your custom requirements.
              </p>
              
              <div className="flex gap-3 mt-6">
                <button
                  onClick={handleCloseEnterpriseModal}
                  className="flex-1 h-12 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmEnterprisePlan}
                  className="flex-1 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium"
                >
                  Yes, Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlans; 